import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Icon,
  Button,
  Input,
  Checkbox,
  message,
  Select,
  Switch,
  Collapse,
  Modal,
} from "antd";
import { Translate } from "react-translated";
import AddressField from "../../components/address-field";
import F from "../../Functions";
import Dropzone from "react-dropzone";
import Microsoft_booking from "./microsoft_booking";
import ManualMicrosoftBooking from "./manual_microsoft_booking";
import SchedulingLink from "./Components/SchedulingLink";
import { AGENCY_LOGO, AGENCY_LOGO_REMOVED_SUCCESSFULLY, ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_IMAGE, FAILED_TO_REMOVE_PROFILE_PHOTO, NO, PROFILE_PHOTO, REMOVED_SUCCESSFULLY, TYPE_OF_SCHEDULING_CALL, UPDATE_PROFILE, YES } from "../../utils/Constants";
import DownloadModal from "../Dashboard/DownloadModal";
import { DELETE_EA_USER_DP_URL, DELETE_EA_USER_PROFILE_PIC, DELETE_USER_DP_URL } from "../../utils/Api_enums";
import axios from "../../api";

const Option = Select.Option;
const { TextArea } = Input;
const { Panel } = Collapse;

class Profile extends Component {
  encrypt = (text) => {
    return btoa(text);
  };

  state = {
    agency_id: '',
    pass_loading: false,
    carrier: "",
    underlying_limit_checked: [],
    address_updated: false,
    showdownloadModal: false,
    minimum_liability_limits: [
      "Home",
      "Auto",
      "Suggested Minimum Life Insurance",
    ],
    minimum_liability_limits_bureau_mi: [
      "Home",
      "Auto",
      "Suggested Minimum Life Insurance",
    ],
    underlying_limits_ext: {},
    underlying_limits: {
      Home: {
        title: "Select Minimum Liability Limits",
        options: ["$100,000", "$300,000", "$500,000", "$1,000,000"],
      },
      Auto: {
        title: "Select Minimum Liability Limits",
        options: [
          "$25,000/$50,000",
          "$50,000/$100,000",
          "$100,000/$300,000",
          "$250,000/$500,000",
          "$500,000/$500,000",
          "$500,000/$1,000,000",
        ],
      },
      "Suggested Minimum Life Insurance": {
        // title: "Select Minimum Liability Limits",
        title: "Select Minimum Liability Limits",
        options: ["3x", "5x", "7x", "10x"],
      },
      default: {
        title: "Select Minimum Liability Limits",
        options: [
          "$25,000/$50,000",
          "$50,000/$100,000",
          "$100,000/$300,000",
          "$250,000/$500,000",
          "$500,000/$500,000",
          "$500,000/$1,000,000",
        ],
      },
    },
    underlying_limits_bureau_mi: {
      Home: {
        title: "Select Minimum Liability Limits",
        options: ["100,000", "300,000", "500,000"],
      },
      Auto: {
        title: "Select Minimum Liability Limits",
        options: ["100/300", "250/500", "500/500"],
      },
      "Suggested Minimum Life Insurance": {
        title: "Select Minimum Liability Limits",
        options: ["3x", "5x", "7x", "10x"],
      },
      default: {
        title: "Select Minimum Liability Limits",
        options: ["100/300", "250/500", "500/500"],
      },
    },
  };

  copyToClipboard = (e) => {
    window.document.getElementById("linkTextarea").select();
    window.document.execCommand("copy");
    window.document.getElementById("linkTextarea").focus();
    message.success("Copied!");
  };

  generateArrayOfYears = () => {
    var min = new Date().getFullYear();
    var max = min + 15;
    var years = [];

    for (var i = min; i < max; i++) {
      years.push(i);
    }
    return years;
  };

  componentDidMount = () => {
    const { user } = this.props;

    this.setCarrier(user.carrier, false);
  };

  /**
   *
   * @param {*} val
   * @param {*} update
   */
  setCarrier = (val, update = true) => {
    const { user } = this.props;

    // for e.g: val => `Farm Bureau`

    const {
      minimum_liability_limits,
      minimum_liability_limits_bureau_mi,
      underlying_limits,
      underlying_limits_bureau_mi,
    } = this.state;

    // ["Home","Auto","Suggested Minimum Life Insurance"]
    const cur_minimum_liability_limits = minimum_liability_limits_bureau_mi;
    // val && val === "Farm Bureau"
    //   ? minimum_liability_limits_bureau_mi
    //   : minimum_liability_limits;

    /**
     * [
     *   {"label":"Home","value":"Home"},
     *   {"label":"Auto","value":"Auto"},
     *   {"label":"Suggested Minimum Life Insurance","value":"Suggested Minimum Life Insurance"}
     * ]
     */
    const minimum_liability_limits_ext = cur_minimum_liability_limits.map(
      (value) => {
        return {
          label: value,
          value: value,
        };
      }
    );

    let minimum_liability_limits_checkboxes_checked = [];
    let minimum_liability_limits_value_ext = {};

    const underlying_limits_ext =
      val && val === "Farm Bureau"
        ? underlying_limits_bureau_mi
        : underlying_limits;

    // {"Auto":"","Suggested Minimum Life Insurance":""}
    if (user.minimum_liability_limits_ext) {
      const user_minimum_liability_limits_ext = JSON.parse(
        user.minimum_liability_limits_ext
      );

      // {"Auto":"","Suggested Minimum Life Insurance":""}

      for (let x in user_minimum_liability_limits_ext) {
        if (
          cur_minimum_liability_limits &&
          cur_minimum_liability_limits.includes(x)
        ) {
          minimum_liability_limits_checkboxes_checked.push(x);

          const selectedValue = user_minimum_liability_limits_ext[x];

          const underlying_limits = underlying_limits_ext[x]
            ? underlying_limits_ext[x]
            : underlying_limits_ext["default"];

          if (underlying_limits.options.includes(selectedValue)) {
            minimum_liability_limits_value_ext[x] = selectedValue;
          } else {
            minimum_liability_limits_value_ext[x] = "";
          }
        }
      }
    }

    this.setState(
      {
        carrier: val,
        minimum_liability_limits_ext,
        minimum_liability_limits_checkboxes_checked,
        minimum_liability_limits_value_ext,
        underlying_limits_ext,
      },
      () => {
        if (update) {
          this.props.updateField("carrier", val);

          this.updateAllMinimumLiabilities();
        }
      }
    );
  };

  updateLiabilityLimitsData = (value) => {
    const { minimum_liability_limits_value_ext } = this.state;

    const minimum_liability_limits_checkboxes_checked = value;
    let update_limits_value_ext = {};

    value.forEach((key) => {
      if (minimum_liability_limits_value_ext[key] !== undefined) {
        update_limits_value_ext[key] = minimum_liability_limits_value_ext[key];
      } else {
        update_limits_value_ext[key] = "";
      }
    });

    this.setState(
      {
        minimum_liability_limits_checkboxes_checked,
        minimum_liability_limits_value_ext: update_limits_value_ext,
      },
      () => this.updateAllMinimumLiabilities()
    );
  };

  updateMinimumLiability = (key, value) => {
    const { minimum_liability_limits_value_ext } = this.state;

    minimum_liability_limits_value_ext[key] = value;

    this.setState({ minimum_liability_limits_value_ext }, () =>
      this.updateAllMinimumLiabilities()
    );
  };

  updateAllMinimumLiabilities = () => {
    const { updateField } = this.props;

    const { minimum_liability_limits_value_ext } = this.state;

    if (minimum_liability_limits_value_ext.hasOwnProperty("HOME")) {
      updateField(
        "home_underlying_limit",
        minimum_liability_limits_value_ext["HOME"]
      );
    } else {
      updateField("home_underlying_limit", "");
    }

    if (minimum_liability_limits_value_ext.hasOwnProperty("AUTO")) {
      updateField(
        "auto_underlying_limit",
        minimum_liability_limits_value_ext["AUTO"]
      );
    } else {
      updateField("auto_underlying_limit", "");
    }

    if (
      minimum_liability_limits_value_ext.hasOwnProperty(
        "Suggested Minimum Life Insurance"
      )
    ) {
      updateField(
        "suggested_minimum_life_insurance",
        minimum_liability_limits_value_ext["Suggested Minimum Life Insurance"]
      );
    } else {
      updateField("suggested_minimum_life_insurance", "");
    }

    updateField(
      "minimum_liability_limits_ext",
      JSON.stringify(minimum_liability_limits_value_ext)
    );
  };

  renderMinimumLiabilityValues = () => {
    const {
      minimum_liability_limits_checkboxes_checked,
      minimum_liability_limits_value_ext,
      underlying_limits_ext,
    } = this.state;

    return (
      <Row gutter={16}>
        {minimum_liability_limits_checkboxes_checked &&
          minimum_liability_limits_checkboxes_checked.length > 0
          ? minimum_liability_limits_checkboxes_checked.map((value, i) => {
            const underlying_limits = underlying_limits_ext[value]
              ? underlying_limits_ext[value]
              : underlying_limits_ext["default"];

            /**
          options: (4) ['3x', '5x', '7x', '10x']
          title: "Select Minimum Liability Limits"
          */

            if (i) {
              return (
                <Col key={i} md={12} span={24}>
                  <div className="inputField">
                    <label>{value}:</label>
                    <Select
                      value={
                        value == "Suggested Minimum Life Insurance" &&
                          minimum_liability_limits_value_ext[value] == ""
                          ? "3x"
                          : minimum_liability_limits_value_ext[value] ||
                          "Select Minimum Liability Limits"
                      }
                      style={{ width: "100%" }}
                      onChange={(newValue) =>
                        this.updateMinimumLiability(value, newValue)
                      }
                    >
                      {/* <Option value="">
                          <Translate text={underlying_limits.title} />
                          ...
                        </Option> */}

                      {underlying_limits.options.map((subValue, ii) => (
                        <Option key={ii} value={subValue}>
                          {subValue}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </Col>
              );
            } else {
              return (
                <Col key={i} md={12} span={24}>
                  <div className="inputField">
                    <label>{value}:</label>
                    <Select
                      value={minimum_liability_limits_value_ext[value]}
                      style={{ width: "100%" }}
                      onChange={(newValue) =>
                        this.updateMinimumLiability(value, newValue)
                      }
                    >
                      <Option value="">
                        <Translate text={underlying_limits.title} />
                        ...
                      </Option>

                      {underlying_limits.options.map((subValue, ii) => (
                        <Option key={ii} value={subValue}>
                          {subValue}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </Col>
              );
            }
          })
          : null}
      </Row>
    );
  };



  showDeleteConfirm = (type, index = null) => {
    Modal.confirm({
      title: ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_IMAGE,
      okText: YES,
      cancelText: NO,
      onOk: () => {
        if (type === "profile_pic" || type == "agency_photo") {
          const newPics = [...this.props.fileAttributes[type]];
          newPics.splice(index, 1);
          this.props.fileAttributes_upload([type], {
            ...this.props.fileAttributes,
            [type]: newPics,
          });
          message.success(`${type == 'profile_pic' ? PROFILE_PHOTO : AGENCY_LOGO} ${REMOVED_SUCCESSFULLY}`);

        } else if (type === "dp_url" || type == "agency_photo_url") {
          axios.post(DELETE_EA_USER_PROFILE_PIC, {
            id: index,
            type: type
          })
            .then(res => {
              if (res.data.success) {
                message.success(res.data.message);
              } else {
                message.error(res.data.message || FAILED_TO_REMOVE_PROFILE_PHOTO);
              }
            })
            .catch(err => {
              console.error("Error:", err);
              message.error("Something went wrong.");
            })
            .finally(() => {
              setTimeout(() => window.location.reload(), 300);
            });

        } else if (type === "agency_logo") {
          this.setState({
            agencyLogo: null
          });
          message.success(AGENCY_LOGO_REMOVED_SUCCESSFULLY);
        }
      }
    });
  }


  render() {
    const {
      loading,
      user,
      card,
      agency,
      carrier,
      updateField,
      updateCCField,
      updateAgencyField,
      change_payment_method,
      update,
      fileAttributes,
      fileAttributes_upload,
    } = this.props;

    let link = "";
    if (user.user_agency_assoc.length > 0) {
      const agencyIdEncrypted = this.encrypt(user.user_agency_assoc[0].agency_id);
      const userIdEncrypted = this.encrypt(user.id);
      link = `${window.location.origin}/app/create-bfile/${agencyIdEncrypted}/${userIdEncrypted}`;
      console.log(user)
      // "https://bfilesystem.com/app/create-bfile/" +
      // user.user_agency_assoc[0].agency_id +
      // "/" +
      // user.id;
    }

    const calendly_connect = F.isProductionHost()
      ? "https://auth.calendly.com/oauth/authorize?client_id=TOmzViVrU2VxnA9XAxFyLwRBJB3wFqZso2Y45b3BlEA&response_type=code&redirect_uri=https://bfilesystem.com/api/auth/calendly"
      : window.location.host === "bfiledev.netlink.com"
        ? "https://auth.calendly.com/oauth/authorize?client_id=hUALsvqvT91JNB8crNJiAhQZGwRB09jriZsLfXfhG_E&response_type=code&redirect_uri=https://bfiledev.netlink.com/api/auth/calendly"
        : "https://auth.calendly.com/oauth/authorize?client_id=hUALsvqvT91JNB8crNJiAhQZGwRB09jriZsLfXfhG_E&response_type=code&redirect_uri=https://beta.bfilesystem.com/api/auth/calendly";

    const userType = this.props.parentInstance.props.auth.user.user_type;

    return (
      <div>
        <Card
          type="inner"
          title={<Translate text={`Personal Information`} />}
          loading={loading}
          style={{ marginBottom: 20 }}
        >
          <div>
            <Row gutter={16}>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    {/* <Translate text={`First Name`} />: */}
                    <Translate text={`First Name`} /> <span className="required-symbol">*</span>
                  </label>
                  <Input
                    value={user.first_name}
                    onChange={(e) => updateField("first_name", e.target.value)}
                    maxLength={50}
                  />
                </div>
              </Col>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    {/* <Translate text={`Last Name`} />: */}
                    <Translate text={`Last Name`} /> <span className="required-symbol">*</span>
                  </label>
                  <Input
                    value={user.last_name}
                    onChange={(e) => updateField("last_name", e.target.value)}
                    maxLength={50}
                  />
                </div>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    {/* <Translate text={`Email`} />: */}
                    <Translate text={`Email`} /> <span className="required-symbol">*</span>
                  </label>
                  <Input
                    value={user.email}
                    onChange={(e) => updateField("email", e.target.value)}
                  />
                </div>
              </Col>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    {/* <Translate text={`Agency Name`} />: */}
                    <Translate text={`Agency Name`} /> <span className="required-symbol">*</span>
                  </label>
                  <Input
                    value={agency != null ? agency.name : ""}
                    onChange={(e) => updateAgencyField("name", e.target.value)}
                  />
                </div>
              </Col>
            </Row>
            {/* <Row gutter={16}>
              <Col md={12} span={24}>
                                <div className="inputField">
                                    <label><Translate text={`Email`} />:</label>
                                    <Input value={user.email} onChange={(e) => updateField('email', e.target.value)} />
                                </div>
                            </Col> 
              <Col md={24} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Company Name`} />:
                  </label>
                  <Input
                    value={user.company_name}
                    onChange={(e) =>
                      updateField('company_name', e.target.value)
                    }
                  />
                </div>
              </Col>
            </Row> */}
            <Row gutter={16}>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    {/* <Translate text={`Phone`} />: */}
                    <Translate text={`Phone`} /> <span className="required-symbol">*</span>
                  </label>
                  <Input
                    value={F.phone_format(user.phone)}
                    // onChange={(e) => updateField("phone", e.target.value)}
                    onChange={(e) => {
                      if (e.target.value.trim().length <= 14) {
                        const updateNumber = F.phone_format(e.target.value);
                        updateField("phone", updateNumber);
                      }
                    }}
                  />
                </div>
              </Col>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Mobile`} />
                  </label>
                  <Input
                    value={F.phone_format(user.mobile_number)}
                    onChange={(e) => {
                      if (e.target.value.trim().length <= 14) {
                        const updateNumber = F.phone_format(e.target.value);
                        updateField("mobile_number", updateNumber);
                      }
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Street Address`} />
                  </label>
                  <AddressField
                    value={user.street_one ? user.street_one : user.address}
                    onChange={(val) => {
                      updateField("street_one", val)
                      updateField("address", val)
                      updateField("address_update", true)
                    }}
                  />
                </div>
              </Col>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Street Address 2`} />
                  </label>
                  <AddressField
                    value={user.street_two}
                    onChange={(val) => {
                      updateField("street_two", val)
                      updateField("address_update", true)
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col md={6} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`City`} />
                  </label>
                  <Input
                    value={user.city}
                    onChange={(e) => {
                      updateField("city", e.target.value)
                      updateField("address_update", true)
                    }
                    }
                  />
                </div>
              </Col>
              <Col md={6} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`State`} />
                  </label>
                  <Input
                    value={user.state}
                    onChange={(e) => {
                      updateField("state", e.target.value)
                      updateField("address_update", true)
                    }
                    }
                  />
                </div>
              </Col>
              <Col md={6} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Zipcode`} />
                  </label>
                  <Input
                    value={user.zipcode}
                    onChange={(e) => {
                      updateField("zipcode", e.target.value)
                      updateField("address_update", true)
                    }
                    }
                  />
                </div>
              </Col>
              <Col md={6} span={24}>
                <div className="inputField">
                  <label>Country</label>
                  <Input disabled value={"United States"} />
                </div>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Timezone`} />
                    <span className='asteriskIcon'>*</span>
                  </label>
                  <Select
                    defaultValue={user.timezone}
                    style={{ width: "100%" }}
                    onChange={(value) => updateField("timezone", value)}
                  >
                    <Option value={""}>
                      <Translate text={`Select Timezone`} />
                      ...
                    </Option>
                    <Option value="US/Samoa">
                      <Translate text={`Samoa Time Zone`} /> (-11:00)
                    </Option>
                    <Option value="US/Hawaii">
                      <Translate text={`Hawaii-Aleutian Time Zone`} /> (-10:00)
                    </Option>
                    <Option value="US/Alaska">
                      <Translate text={`Alaska Time Zone`} /> (-09:00)
                    </Option>
                    <Option value="US/Pacific">
                      <Translate text={`Pacific Time Zone`} /> (-08:00)
                    </Option>
                    <Option value="US/Mountain">
                      <Translate text={`Mountain Time Zone`} /> (-07:00)
                    </Option>
                    <Option value="US/Central">
                      <Translate text={`Central Time Zone`} /> (-06:00)
                    </Option>
                    <Option value="US/Eastern">
                      <Translate text={`Eastern Time Zone`} /> (-05:00)
                    </Option>
                  </Select>
                </div>
              </Col>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Welcome/Thank You Calls Default Date`} />
                  </label>
                  <Select
                    defaultValue={user.default_date}
                    style={{ width: "100%" }}
                    onChange={(value) => updateField("default_date", value)}
                  >
                    <Option value={null}>
                      <Translate text={`Select Default Date`} />
                      ...
                    </Option>
                    <Option value={0}>
                      <Translate text={`Immediately`} />
                    </Option>
                    <Option value={5}>
                      5 <Translate text={`days`} />
                    </Option>
                    <Option value={10}>
                      10 <Translate text={`days`} />
                    </Option>
                    <Option value={15}>
                      15 <Translate text={`days`} />
                    </Option>
                    <Option value={20}>
                      20 <Translate text={`days`} />
                    </Option>
                    <Option value={25}>
                      25 <Translate text={`days`} />
                    </Option>
                    <Option value={30}>
                      30 <Translate text={`days`} />
                    </Option>
                  </Select>
                </div>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    {/* <Translate text={`Language`} />: */}
                    <Translate text={`Language`} /> <span className="required-symbol">*</span>
                  </label>
                  <Select
                    defaultValue={user.language}
                    style={{ width: "100%" }}
                    onChange={(value) => updateField("language", value)}
                  >
                    <Option value={""}>
                      <Translate text={`Select Language`} />
                      ...
                    </Option>
                    <Option value="en">
                      <Translate text={`English`} />
                    </Option>
                    <Option value="es">
                      <Translate text={`Spanish`} />
                    </Option>
                  </Select>
                </div>
              </Col>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    {/* <Translate text={`Carriers`} />: */}
                    <Translate text={`Carriers`} /> <span className="required-symbol">*</span>
                  </label>
                  <Select
                    style={{ width: "100%" }}
                    value={user.carrier}
                    onChange={(value) => this.setCarrier(value)}
                  >
                    <Option value={""}>
                      <Translate text={`Select Carriers`} />
                      ...
                    </Option>
                    <Option value="Allstate">
                      <Translate text={`Allstate`} />
                    </Option>
                    <Option value="Farmers">
                      <Translate text={`Farmers`} />
                    </Option>
                    <Option value="Farm Bureau">
                      {/* <Translate text={`Farm Bureau - MI`} /> */}
                      <Translate text={`Farm Bureau`} />
                    </Option>
                    <Option value="Country Financial">
                      <Translate text={`Country Financial`} />
                    </Option>
                    {/* <Option value="Horace Mann">
                    <Translate text={`Horace Mann`} />
                  </Option> */}
                    <Option value="Independent Agent">
                      <Translate text={`Independent Agent`} />
                    </Option>
                  </Select>
                </div>
              </Col>
            </Row>
            {/* <Row gutter={16} className="mt-20">
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Virtual Meeting Link (Zoom, WebEx etc.)`} /> <span className="required-symbol"></span>
                  </label>
                  <Input
                    value={user.virtual_link}
                    onChange={(e) =>
                      updateField("virtual_link", e.target.value)
                    }
                  />
                </div>
              </Col>
            </Row> */}
            <Row gutter={16}>
              <Col md={24} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Upload Profile Photo`} />

                  </label>
                  {/* <Input value={users.name} onChange={(e) => updateField('name', e.target.value)} /> */}
                  <Dropzone
                    accept={["image/png", "image/jpg", "image/jpeg"]}
                    maxFiles={1}
                    onDrop={(files, reject) => {
                      if (
                        !files.length &&
                        reject.length &&
                        reject.map((e) => e.errors[0])[0].code ===
                        "too-many-files"
                      ) {
                        message.error("Please select only one photo");
                      } else {
                        files = files.map((file) =>
                          Object.assign(file, {
                            preview: URL.createObjectURL(file),
                          })
                        );

                        fileAttributes_upload("profile_pic", {
                          ...fileAttributes,
                          profile_pic: [...files],
                        });
                      }
                    }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div className="container">
                        <div className="disp-flex">
                          <div
                            {...getRootProps({
                              className: "dropzone",
                              onDrop: (event) => event.stopPropagation(),
                            })}
                          >
                            <input {...getInputProps()} />
                            <span className="btn-drop">Browse</span>
                          </div>
                          <p>
                            Image files (.jpg, .png) here, click to select files
                          </p>
                        </div>
                        {/* Profile Photo */}
                        <div className="box-bors">
                          <h4>Uploaded File :</h4>
                          {fileAttributes.profile_pic &&
                            fileAttributes.profile_pic.map((pic, index) => (
                              <li key={index} className="pic-display-position">
                                <Icon
                                  type="close"
                                  className="cross-close"
                                  onClick={() => this.showDeleteConfirm("profile_pic", index)}
                                />
                                <img
                                  style={{ width: "100px" }}
                                  src={pic.preview}
                                  onLoad={() =>
                                    URL.revokeObjectURL(pic.preview)
                                  }
                                />
                                {/* {pic.path} <br /> <b>Size : </b>
                                {(pic.size / (1024 * 1024)).toFixed(2)} MB */}
                              </li>
                            ))}
                          {!fileAttributes.profile_pic.length && user.dp_url && (
                            <li className="pic-display-position">
                              <Icon
                                type="close"
                                className="cross-close"
                                onClick={() => this.showDeleteConfirm("dp_url", user.id)}
                              />
                              <img
                                style={{ width: "100px" }}
                                src={user.dp_url}
                              />
                            </li>
                          )}
                        </div>
                      </div>
                    )}
                  </Dropzone>
                </div>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col md={24} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Upload Agency Logo`} />

                  </label>
                  {/* <Input value={users.name} onChange={(e) => updateField('name', e.target.value)} /> */}
                  <Dropzone
                    accept={["image/png", "image/jpg", "image/jpeg"]}
                    maxFiles={1}
                    onDrop={(files, reject, e) => {
                      if (
                        !files.length &&
                        reject.length &&
                        reject.map((e) => e.errors[0])[0].code ===
                        "too-many-files"
                      ) {
                        message.error("Please select only one photo");
                      } else {
                        files = files.map((file) =>
                          Object.assign(file, {
                            preview: URL.createObjectURL(file),
                          })
                        );

                        fileAttributes_upload("agency_photo", {
                          ...fileAttributes,
                          agency_photo: [...files],
                        });
                      }
                    }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div className="container">
                        <div className="disp-flex">
                          <div
                            {...getRootProps({
                              className: "dropzone",
                              onDrop: (event) => event.stopPropagation(),
                            })}
                          >
                            <input {...getInputProps()} />
                            <span className="btn-drop">Browse</span>
                          </div>
                          <p>
                            Image files (.jpg, .png) here, click to select files
                          </p>
                        </div>
                        <div className="box-bors">
                          <h4>Uploaded File :</h4>
                          {fileAttributes.agency_photo &&
                            fileAttributes.agency_photo.map((pic, index) => (
                              <li key={index} className="pic-display-position">
                                <Icon
                                  type="close"
                                  className="cross-close"
                                  onClick={() => this.showDeleteConfirm("agency_photo", index)}
                                />
                                <img
                                  style={{ width: "100px" }}
                                  src={pic.preview}
                                  onLoad={() =>
                                    URL.revokeObjectURL(pic.preview)
                                  }
                                />
                                {/* <b>filename : </b>
                                {pic.path} <br /> <b>Size : </b>
                                {(pic.size / (1024 * 1024)).toFixed(2)} MB */}
                              </li>
                            ))}

                          {!fileAttributes.agency_photo.length &&
                            agency.agency_photo_url && (
                              <li className="pic-display-position">
                                <Icon
                                  type="close"
                                  className="cross-close"
                                  onClick={() => this.showDeleteConfirm("agency_photo_url", agency.id)}
                                />
                                <img
                                  style={{ width: "100px" }}
                                  src={agency.agency_photo_url}
                                />
                              </li>
                            )}
                        </div>
                      </div>
                    )}
                  </Dropzone>
                </div>
              </Col>
            </Row>

            {/*  For Reviewer  */}
            <div>
              {
                (userType === "EA" || userType === "LSP") && (
                  <div>
                    <h2>
                      <Translate text={`Appointment Links`} />
                    </h2>
                    <SchedulingLink
                      parentInstance={this.props.parentInstance}
                      type_of_call={TYPE_OF_SCHEDULING_CALL.REVIEW}
                    // schedule_meetings={this.props.schedule_meetings}
                    />
                  </div>
                )
              }

            </div>
            {/* For Follow Up */}


            {/* {!this.props.has_calendly ? (
              <div>
                <h2>
                  <Translate text={`Connect Calendly`} />
                </h2>
                <a href={calendly_connect}>
                  <Button>Connect Calendly</Button>
                </a>
                <br />
                <br />
              </div>
            ) : (
              <div>
                <h2>
                  <Translate text={`Connect Calendly`} />
                </h2>
                <Button onClick={() => this.props.logoutCalendly()}>
                  Logout
                </Button>
                <br />
                <br />
              </div>
            )}  */}

            {/* {this.props.has_calendly ? (
              <div>
                <h2>
                  <Translate text={`Calendly Settings`} />
                </h2>
                <Row gutter={16}>
                  <Col md={12} span={24}>
                    <div className="inputField">
                      <label>
                        <Translate text={`RS Setup Appointment Event Type`} />:
                      </label>
                      <Select
                        // defaultValue={user.calendly_rs_setup_appointment}
                        defaultValue={F.getSelectedCalendlyEventType(
                          user.calendly_rs_setup_appointment,
                          this.props.calendly_event_types
                        )}
                        style={{ width: "100%" }}
                        onChange={(value) =>
                          updateField("calendly_rs_setup_appointment", value)
                        }
                      >
                        <Option value={null}>
                          <Translate text={`Select Event Type`} />
                          ...
                        </Option>
                        {this.props.calendly_event_types.map(
                          (event_type, i) => (
                            <Option key={i} value={event_type.uri}>
                              {event_type.name}
                            </Option>
                          )
                        )}
                      </Select>
                    </div>
                  </Col>
                </Row>
              </div>
            ) : null}  */}

            {/* {this.props.has_calendly ? (
              <div>
                <Row gutter={16}>
                  <Col md={12} span={24}>
                    <div className="inputField">
                      <label>
                        <Translate text={`VO Setup Appointment Event Type`} />:
                      </label>
                      <Select
                        // defaultValue={user.calendly_vo_setup_appointment}
                        defaultValue={F.getSelectedCalendlyEventType(
                          user.calendly_vo_setup_appointment,
                          this.props.calendly_event_types
                        )}
                        style={{ width: "100%" }}
                        onChange={(value) =>
                          updateField("calendly_vo_setup_appointment", value)
                        }
                      >
                        <Option value={null}>
                          <Translate text={`Select Event Type`} />
                          ...
                        </Option>
                        {this.props.calendly_event_types.map(
                          (event_type, i) => (
                            <Option key={i} value={event_type.uri}>
                              {event_type.name}
                            </Option>
                          )
                        )}
                      </Select>
                    </div>
                  </Col>
                </Row>
              </div>
            ) : null}  */}

            {/* <Microsoft_booking {...this.props} /> */}
            {/* <ManualMicrosoftBooking {...this.props} />  */}

            <Row gutter={16}>
              <Col md={24} span={24}>
                <Collapse accordion>
                  <Panel header={<Translate text={`Internal System Calendar`} />} key="calendar">
                    {/* <div className="inputField"> */}
                    {/* <label>
                    <Translate text={`Internal System Calendar`} />:
                  </label> */}
                    <Collapse>
                      {[
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday",
                      ].map((day, i) => (
                        <Panel header={day} key={i}>
                          <div className="checkboxes">
                            {this.props.appointment_hours[day].map((hour, h) => (
                              <span key={day + "_" + hour.value}>
                                <Checkbox
                                  checked={hour.checked}
                                  onChange={(e) =>
                                    this.props.update_appointment_hours(
                                      day,
                                      h,
                                      e.target.checked
                                    )
                                  }
                                >
                                  <span
                                    style={{
                                      display: "inline-block",
                                      minWidth: 75,
                                    }}
                                  >
                                    {hour.value}
                                  </span>
                                </Checkbox>
                              </span>
                            ))}
                          </div>
                        </Panel>
                      ))}
                    </Collapse>
                    {/* </div> */}
                  </Panel>
                </Collapse>
              </Col>
            </Row>


            <br />

            <h2>
              <Translate text={`Update Password`} />
            </h2>
            <Row gutter={16}>
              <Col md={12} span={24}>
                <div className="inputField">
                  <Button onClick={() => this.props.requestPassword()}
                    className="borderRadius-28"
                  >
                    <Translate text={`Request a new Password`} />
                  </Button>
                </div>
              </Col>
            </Row>
            <h2>
              <Translate text={"Export Report"} />
            </h2>
            <Row gutter={16}>
              <Col md={12} span={24}>
                <div className="inputField">
                  <Button onClick={() => {
                    this.setState({
                      showdownloadModal: true
                    })
                  }
                  }
                    className="borderRadius-28"
                  >
                    <Translate text={`Export B File Report`} />
                  </Button>
                </div>
              </Col>
            </Row>
            {/* <h2>
              <Translate text={`Notifications`} />
            </h2> */}
            {/* <Row gutter={16}> */}
            {/* <Col md={12} span={24}>
                <div className="inputField">
                  <Switch
                    checked={user.email_cron_notification ? true : false}
                    onChange={(checked) =>
                      updateField("email_cron_notification", checked ? 1 : 0)
                    }
                  />
                  <span style={{ marginLeft: 10 }}>
                    <Translate text={`Reminder Notifications`} />
                  </span>
                </div>
              </Col> */}
            {/* <Col md={12} span={24}>
                <div className="inputField">
                  <Switch
                    checked={user.email_game_notification ? true : false}
                    onChange={(checked) =>
                      updateField("email_game_notification", checked ? 1 : 0)
                    }
                  />
                  <span style={{ marginLeft: 10 }}>
                    <Translate text={`Gamification Notifications`} />
                  </span>
                </div>
              </Col> */}
            {/* <Col md={12} span={24}>
                <div className="inputField">
                  <Switch
                    checked={user.email_sale_notification ? true : false}
                    onChange={(checked) =>
                      updateField("email_sale_notification", checked ? 1 : 0)
                    }
                  />
                  <span style={{ marginLeft: 10 }}>
                    <Translate text={`Sale Notifications`} />
                  </span>
                </div>
              </Col> */}
            {/* </Row> */}

            {/* <h2><Translate text={`Agent Minimum Liability Limits`} /></h2>
                        <Row gutter={16}>
                            <Col md={12} span={24}>
                                <div className="inputField">
                                    <label><Translate text={`Minimum liability limits`} />:</label>
                                    <Select defaultValue={user.minimum_liability_limits} style={{ width: '100%' }} onChange={(value) => updateField('minimum_liability_limits', value)}>
                                        <Option value={null}><Translate text={`Select Liability Limits`} />...</Option>
                                        <Option value={"$25,000/$50,000"}>$25,000/$50,000</Option>
                                        <Option value={"$50,000/$100,000"}>$50,000/$100,000</Option>
                                        <Option value={"$100,000/$300,000"}>$100,000/$300,000</Option>
                                        <Option value={"$250,000/$500,000"}>$250,000/$500,000</Option>
                                        <Option value={"$500,000/$1,000,000"}>$500,000/$1,000,000</Option>
                                    </Select>
                                </div>
                            </Col>
                        </Row> */}

            <h2>
              <Translate text={`Change Minimum Liability Limits`} />
            </h2>
            <Checkbox.Group
              value={this.state.minimum_liability_limits_checkboxes_checked}
              onChange={(value) => {
                this.updateLiabilityLimitsData(value);
              }}
            >
              <Row>
                {this.state.minimum_liability_limits_ext &&
                  this.state.minimum_liability_limits_ext.length > 0 &&
                  this.state.minimum_liability_limits_ext.map(
                    (liability, i) => {
                      return (
                        <Col key={i} span={14}>
                          <Checkbox value={liability.value}>
                            {liability.label}
                          </Checkbox>
                          <br />
                        </Col>
                      );
                    }
                  )}
              </Row>
            </Checkbox.Group>

            <br />
            <br />
            {this.renderMinimumLiabilityValues()}

            <h2>
              <Translate text={`Change Credit Card`} />
            </h2>
            {change_payment_method ? (
              <Row gutter={16}>
                <Col md={24} span={24}>
                  <div className="inputField">
                    <label>
                      <Translate text={`Card Number`} />:
                    </label>
                    <Input
                      value={card.card_number}
                      onChange={(e) =>
                        updateCCField("card_number", e.target.value)
                      }
                    />
                  </div>
                </Col>
                <Col md={8} span={24}>
                  <div className="inputField">
                    <label>
                      <Translate text={`Exp Month`} />:
                    </label>
                    <Select
                      defaultValue={card.exp_month}
                      style={{ width: "100%" }}
                      onChange={(value) => updateCCField("exp_month", value)}
                    >
                      <Option value="">
                        <Translate text={`Month...`} />
                      </Option>
                      <Option value="01">
                        <Translate text={`January`} />
                      </Option>
                      <Option value="02">
                        <Translate text={`February`} />
                      </Option>
                      <Option value="03">
                        <Translate text={`March`} />
                      </Option>
                      <Option value="04">
                        <Translate text={`April`} />
                      </Option>
                      <Option value="05">
                        <Translate text={`May`} />
                      </Option>
                      <Option value="06">
                        <Translate text={`June`} />
                      </Option>
                      <Option value="07">
                        <Translate text={`July`} />
                      </Option>
                      <Option value="08">
                        <Translate text={`August`} />
                      </Option>
                      <Option value="09">
                        <Translate text={`September`} />
                      </Option>
                      <Option value="10">
                        <Translate text={`October`} />
                      </Option>
                      <Option value="11">
                        <Translate text={`November`} />
                      </Option>
                      <Option value="12">
                        <Translate text={`December`} />
                      </Option>
                    </Select>
                  </div>
                </Col>
                <Col md={8} span={24}>
                  <div className="inputField">
                    <label>
                      <Translate text={`Exp Year`} />:
                    </label>
                    <Select
                      defaultValue={card.exp_year}
                      style={{ width: "100%" }}
                      onChange={(value) => updateCCField("exp_year", value)}
                    >
                      <Option value="">
                        <Translate text={`Year...`} />
                      </Option>
                      {this.generateArrayOfYears().map((year) => (
                        <Option key={year} value={year + ""}>
                          {year}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </Col>
                <Col md={8} span={24}>
                  <div className="inputField">
                    <label>
                      <Translate text={`Card CVV`} />:
                    </label>
                    <Input
                      value={card.cvc}
                      onChange={(e) => updateCCField("cvc", e.target.value)}
                    />
                  </div>
                </Col>
              </Row>
            ) : (
              <Button
                onClick={() => window.open('https://billing.stripe.com/p/login/14AcMY09x0hNcmO1Zd7g400', '_blank', 'noopener,noreferrer')}
                className="borderRadius-28"
              >
                <Translate text={`Change Payment Method`} />
              </Button>
              // <Button onClick={() => this.props.show_payment_method()}
              //   className="borderRadius-28"
              // >
              //   <Translate text={`Change Payment Method`} />
              // </Button>
            )}
          </div>

          <div className="right-align">
            <Button type="primary" onClick={update.bind(this)}
              className="bg-164897 borderRadius-28"
            >
              <Translate text={`${UPDATE_PROFILE}`} />
            </Button>
          </div>
        </Card>
        {/* Uncomment */}
        {link !== "" ? (
          <Card
            type="inner"
            title={<Translate text={`External B File Creation Link`} />}
          >
            <div>
              <p>
                This link will allow your customers to fill out the B File on
                their own time.
              </p>
              <TextArea
                id="linkTextarea"
                prefix={
                  <Icon type="link" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                value={link}
                style={{ marginBottom: 10 }}
              />
              <div className="right">
                <Button onClick={() => this.copyToClipboard()}
                  className="borderRadius-28"
                >
                  Copy Intelligence Link
                </Button>
              </div>
            </div>
          </Card>
        ) : null}
        {this.state.showdownloadModal &&
          (<DownloadModal
            visible={this.state.showdownloadModal}
            setIsVisible={() => this.setState({ showdownloadModal: false })}
            agency_id={user.user_agency_assoc[0].agency_id}
          />)}
      </div>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/scenes/Profile/ea.js